import { getFlagValue, isFlagEnabled } from '@Redux/actions/flagsmith';
import { APP_ONLY_CORRIDORS_FLAG, INDIVIDUAL } from '@Utils/constants';

export const APP_ONLY_CORRIDORS_FALLBACK_DATA = {
  welcomeScreen: {
    leftColumn: {
      welcomeTitle: 'Great start!',
      description: {
        part1: `You're almost there. `,
        part2: 'Instarem is app only. ',
        part3: 'Download the app and get going.'
      }
    },
    rightColumn: {
      title: 'Download the app now to start sending money from {COUNTRY_NAME}',
      description: {
        shareLinkPart1: `Don't have your mobile handy?`,
        shareLinkPart2: `Use the link below to download later.`
      },
      appLink: 'https://myappdownload.onelink.me/C74i/msitepup',
      emailShare: {
        subject: 'Get started with Instarem – download the app now!',
        body: `Dear customer,

We're excited to have you on board! To get the most out of Instarem, download our app and access all our features on the go.

Know someone who might need it too? Just share the link:

Play Store/App Store: https://www.instarem.com/getapp

See you on the app,
Team Instarem`
      }
    }
  }
};

type CorridorCountry = {
  code: string;
  name: string;
};

export const getAppOnlyCorridorCountryName = (countryCode: string) => {
  const APP_ONLY_CORRIDOR_LIST = getFlagValue(APP_ONLY_CORRIDORS_FLAG);
  return (
    APP_ONLY_CORRIDOR_LIST?.find((country: CorridorCountry) => country.code === countryCode)
      ?.name || ''
  );
};

export const isAppOnlyCorridor = (accountType: string, countryCode: string) => {
  return (
    accountType === INDIVIDUAL &&
    isFlagEnabled(APP_ONLY_CORRIDORS_FLAG) &&
    getFlagValue(APP_ONLY_CORRIDORS_FLAG)?.some(
      (corridor: CorridorCountry) => corridor.code === countryCode
    )
  );
};
